module.exports = __webpack_public_path__ + "img/image8.ad0995f4.png";